import { CKBox } from 'clearkit';

export function CreateNewList() {
  return <CKBox>Create a new prospects list</CKBox>;
}
